// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1518":"4c28caa534500df1","4301":"55ddacb6a88ee1c0","5428":"fc872379ae7067c9","9812":"be4217235fc79c26"}[chunkId] + ".js";
};